'use client';

import React, { FC } from 'react';
import Link from 'next/link';
import { usePathname, useParams } from 'next/navigation';
import styles from './Breadcrumbs.module.scss';
import classNames from 'classnames';
import { ITheme } from '@/src/lib/types/themeInterface';

interface IBreadcrumbs {
    themeData?: Partial<ITheme>;
    className?: string;
}

const Breadcrumbs: FC<IBreadcrumbs> = ({ className, themeData }) => {
    const pathname = usePathname();
    const params = useParams();

    const isStockistTheme = themeData?.slug === 'stockist' || pathname.startsWith('/themes/stockist');
    const isPromptTheme = themeData?.slug === 'prompt' || pathname.startsWith('/themes/prompt');

    const pathSegments = pathname
        .replace('tag', '')
        .split('/')
        .filter((segment) => segment !== '');

    const crumbsStyles = classNames(
        styles.wrapper,
        {
            [styles.dark]: !isPromptTheme && (params?.slug && !pathname.includes('documentation') && !isStockistTheme),
        },
        className
    );

    const toCorrectCapitalize = (str: string) =>
        str
            .split(' ')
            .map((item) => (item !== 'and' ? item.charAt(0).toUpperCase() + item.slice(1) : item))
            .join(' ');

    return (
        <div className={classNames(crumbsStyles, isStockistTheme && styles.breadcrumbs_stockist, isPromptTheme && styles.breadcrumbs_prompt)}>
            <nav className={styles.breadcrumbs}>
                <Link href="/" className={styles.link}>
                    Home
                </Link>
                {pathSegments.map((segment, index) => {
                    const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
                    return (
                        <React.Fragment key={index}>
                            <span className={styles.devider}></span>
                            {segment !== 'documentation' ? (
                                <Link href={path} className={styles.link}>
                                    {toCorrectCapitalize(
                                        segment
                                            .replace(/-/g, ' ')
                                            .replace('privacy-policy', 'Privacy Policy')
                                    )}
                                </Link>
                            ) : (
                                <Link href={'/help-center'} className={styles.link}>
                                    {toCorrectCapitalize(segment)}
                                </Link>
                            )}
                        </React.Fragment>
                    );
                })}
            </nav>
        </div>
    );
};

export default Breadcrumbs;
